const normalizePhoneNumber = (phone) => {
  let normalizedPhone = phone.replace(/\D/g, '');

  if (normalizedPhone.startsWith('+7')) {
    normalizedPhone = '8' + normalizedPhone.slice(2);
  }
  else if (normalizedPhone.startsWith('7')) {
    normalizedPhone = '8' + normalizedPhone.slice(1);
  }

  return normalizedPhone;
};

export default normalizePhoneNumber;